const SelfHeading: React.FC = () => {
  return (
    <h1 className="inline-block text-7xl font-inconsolata">
      Hi, I'm{" "}
      <span className="font-bold tracking-wide" style={{ color: "#19B5FE" }}>
        Savar
      </span>
      !
    </h1>
  );
};

export default SelfHeading;
